/* eslint-disable import/no-unresolved */
import { FormikProps } from "formik";
import { memo, useEffect, useLayoutEffect } from "react";
import { useMutation } from "react-query";
import {
  getQuestionnaireVersion,
  handelIndianCurrencyChange,
  onChangeIndianCurrency
} from "src/helpers/FormDetails";
import { ShareOfLoanOptions } from "src/helpers/FormDetails/LoanDetails";
import { setStaffMember } from "src/redux/Actions/common";
import { MasterAction } from "src/redux/Actions/Masters";
import store from "src/redux/store";
import { SET_RULE_ENGINE } from "src/redux/Types/Masters";
import { callRuleEngine } from "src/services/Master";
import CustomBackDrop from "src/shared/CustomBackDrop";
import { CoverType, partners } from "src/config/constant";
import CustomRadioButton from "src/shared/CustomRadioButton";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import {
  LoanDetails,
  PRODUCT_ID
} from "../../../../../helpers/FormDetails/ProposalDetails/interfaces";
import {
  findKeysByValue,
  loanPageHelperText
} from "../../../../../helpers/FormDetails/ProposalDetails/resources";
import CustomDatePicker from "../../../../../shared/CustomDatePicker";
import CustomHelperText from "../../../../../shared/CustomHelperText";
import CustomSelect from "../../../../../shared/CustomSelect";
import CustomTextField from "../../../../../shared/CustomTextField";

interface Props {
  formik: FormikProps<LoanDetails>;
}
function Loan({
  formik: { errors, handleBlur, setFieldTouched, touched, values, handleChange, setFieldValue }
}: Props) {
  const lifeCoverOptions = useAppSelector((state) => state.masterdata_reducer?.coverOption) || {};
  const loanType = useAppSelector((state) => state.masterdata_reducer?.loanCategory) || {};
  const loanData = useAppSelector((state) => state.loanDetails);
  // const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId);
  const isProportionateLead = useAppSelector((state) => state.common?.isProportionateLead);
  const isProportionateParent = useAppSelector((state) => state.common.isProportionateParentLead);
  const productId = useAppSelector((state) => state.common.productId);
  const leadDetails = useAppSelector((state) => state.common.leadDetails);

  const partnerId = useAppSelector((state) => state.common.leadDetails?.partnerId);
  const questionnaireVersion = getQuestionnaireVersion(
    leadDetails?.Members,
    leadDetails?.proposalStatus
  );
  const { mutate: mutateRuleEngine, isLoading: isRuleEngineLoading } = useMutation(
    () =>
      callRuleEngine(
        productId?.toString()!,
        partnerId!,
        values?.loan?.loanTypeCode!,
        questionnaireVersion
      ),
    {
      retry: false,
      onSuccess: (response) => {
        store.dispatch(setStaffMember(response.staffMember));
        store.dispatch(
          MasterAction(SET_RULE_ENGINE, {
            productMaster: response?.productMaster,
            productId: response?.productId,
            partnerId: response?.partnerId
          })
        );
      }
    }
  );

  useEffect(() => {
    if (values?.loan?.loanTypeCode) {
      mutateRuleEngine();
    }
  }, [values?.loan?.loanTypeCode]);

  // const moratoriumPeriodWithoutInterest =
  //   useAppSelector((state) => state.masterdata_reducer?.moratoriumPeriodWithoutInterest) || {};
  const moratoriumPeriod =
    useAppSelector((state) => state.masterdata_reducer?.moratoriumPeriod) || {};
  const loanTerm = useAppSelector((state) => state.masterdata_reducer?.term) || {};

  const {
    loanDetails: {
      loanCoverOption,
      loanType: loanTypeField,
      loanAccountNo,
      interestAccruals,
      emiAmount,
      moratoriumPeriod: moratoriumPeriodField,
      term,
      loanAmount,
      loanInterestRate,
      disbursementDate,
      lipAccountNo,
      noOfCoBorrowers,
      shareofLoan,
      emiFrequency,
      lifeAssuredShareOfLoan
    } = {} as any
  } = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema) || {};

  useEffect(() => {
    setFieldValue(
      "loan.lifeCoverOptionCode",
      findKeysByValue(lifeCoverOptions, values.loan?.lifeCoverOption) || ""
    );
  }, [values.loan?.lifeCoverOption]);
  useEffect(() => {
    setFieldTouched("loan.moratoriumPeriodWith", true);
  }, [values.loan?.loanTerm]);
  useLayoutEffect(() => {
    if (values.loan?.lifeCoverOptionCode === "level") {
      setFieldValue(
        "loan.moratoriumPeriodWith",
        loanData?.loan?.lifeCoverOptionCode === "level" ? loanData?.loan?.moratoriumPeriodWith : "0"
      );
      setFieldValue(
        "loan.moratoriumPeriodWithout",
        loanData?.loan?.lifeCoverOptionCode === "level"
          ? loanData?.loan?.moratoriumPeriodWithout
          : "0"
      );
      setFieldValue(
        "loan.loanInterestRate",
        loanData?.loan?.lifeCoverOptionCode === "level" ? loanData?.loan?.loanInterestRate : "0"
      );
      setFieldValue(
        "loan.interestPeriod",
        loanData?.loan?.lifeCoverOptionCode === "level" ? loanData?.loan?.interestPeriod : "No"
      );
    } else {
      setFieldValue("loan.moratoriumPeriodWith", loanData?.loan?.moratoriumPeriodWith);
      setFieldValue("loan.moratoriumPeriodWithout", loanData?.loan?.moratoriumPeriodWithout);
      setFieldValue("loan.loanInterestRate", loanData?.loan?.loanInterestRate);
      setFieldValue("loan.interestPeriod", loanData?.loan?.interestPeriod);
    }
  }, [values.loan?.lifeCoverOptionCode]);
  useEffect(() => {
    setFieldValue("loan.loanTypeCode", findKeysByValue(loanType, values.loan?.loanType) || "");
  }, [values.loan?.loanType]);
  useEffect(() => {
    setFieldValue(
      "loan.moratoriumPeriodWithCode",
      findKeysByValue(moratoriumPeriod, values.loan?.moratoriumPeriodWith) || ""
    );
  }, [values.loan?.moratoriumPeriodWith]);
  // useEffect(() => {
  //   setFieldValue(
  //     "loan.moratoriumPeriodWithoutCode",
  //     findKeysByValue(moratoriumPeriodWithoutInterest, values.loan?.moratoriumPeriodWithout) || ""
  //   );
  // }, [values.loan?.moratoriumPeriodWithout]);
  useEffect(() => {
    setFieldValue("loan.loanTermCode", findKeysByValue(loanTerm, values.loan?.loanTerm) || "");
  }, [values.loan?.loanTerm]);

  useLayoutEffect(() => {
    if (values?.loan?.lifeCoverOptionCode === "level" && values.loan?.interestPeriod === "No") {
      setFieldValue("loan.moratoriumPeriodWith", "0");
    }
  }, [values?.loan?.interestPeriod, values?.loan?.lifeCoverOptionCode]);

  useLayoutEffect(() => {
    if (values?.loan?.lifeCoverOptionCode === "reducing") {
      if (
        [PRODUCT_ID.GHS_FOR_JIO, PRODUCT_ID.GCS_SREI, PRODUCT_ID.GCS_CAPRI]?.includes(productId!)
      ) {
        setFieldValue("loan.moratoriumPeriodWith", "0");
      } else {
        setFieldValue("loan.moratoriumPeriodWith", "");
      }
    }
  }, [values?.loan?.interestPeriod, values?.loan?.lifeCoverOptionCode]);

  useEffect(() => {
    if ([PRODUCT_ID.GHS, PRODUCT_ID.GHS_FOR_JIO, PRODUCT_ID.GHS_IDBI]?.includes(productId!)) {
      // Specific handling for productId "GHS"
      if (
        values.loan?.moratoriumPeriodWith &&
        values.loan?.loanTerm &&
        parseInt(values.loan?.moratoriumPeriodWith, 10) >= parseInt(values.loan?.loanTerm, 10)
      ) {
        setFieldValue("loan.moratoriumPeriodWith", "");
      }
    }
  }, [values.loan?.loanTerm, values.loan?.moratoriumPeriodWith, productId]);

  // Filter moratoriumPeriod options based on loanTerm and productId
  const filteredMoratoriumPeriodOptions =
    [PRODUCT_ID.GHS, PRODUCT_ID.GHS_FOR_JIO, PRODUCT_ID.GHS_IDBI]?.includes(productId!) &&
    !values.loan?.loanTerm
      ? (Object.values(moratoriumPeriod) as string[])
      : (Object.values(moratoriumPeriod).filter(
          (period) => parseInt(String(period), 10) < parseInt(values.loan?.loanTerm || "0", 10)
        ) as string[]);
  useEffect(() => {
    if (shareofLoan >= 50) {
      setFieldValue("loan.lifeAssuredShareOfLoan", ShareOfLoanOptions[0]);
    } else if (shareofLoan > 0 && shareofLoan < 50) {
      setFieldValue("loan.lifeAssuredShareOfLoan", ShareOfLoanOptions[1]);
    } else {
      setFieldValue("loan.lifeAssuredShareOfLoan", "");
    }
  }, [shareofLoan]);
  return (
    <div>
      <CustomBackDrop open={isRuleEngineLoading} />
      <span className="flex mb-6 text-base font-bold text-black font-montserrat">Loan Details</span>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
        {loanCoverOption?.visible && (
          <CustomSelect
            requiredStar={loanCoverOption?.required}
            disabledField={loanCoverOption?.disabled || isProportionateLead}
            label={loanCoverOption?.label}
            options={Object.values(lifeCoverOptions)}
            onChange={(e) => {
              handleChange(e);
              if (e.target.value === lifeCoverOptions.reducing && partnerId === partners.JIO) {
                setFieldValue("loan.interestPeriod", "No");
              }
            }}
            setFieldTouched={setFieldTouched}
            name="loan.lifeCoverOption"
            value={values.loan.lifeCoverOption}
            error={errors.loan?.lifeCoverOption}
            touched={touched.loan?.lifeCoverOption}
          />
        )}
        {loanTypeField?.visible && (
          <CustomSelect
            requiredStar={loanTypeField?.required}
            disabledField={loanTypeField?.disabled || isProportionateLead}
            label={loanTypeField?.label}
            options={Object.values(loanType)}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="loan.loanType"
            value={values.loan.loanType}
            error={errors.loan?.loanType}
            touched={touched.loan?.loanType}
          />
        )}
        {loanAccountNo?.visible && (
          <CustomTextField
            requiredStar={loanAccountNo?.required}
            disabledField={loanAccountNo?.disabled || isProportionateLead}
            label={loanAccountNo?.label}
            onChange={handleChange}
            handleBlur={handleBlur}
            value={values.loan.loanAcNo}
            name="loan.loanAcNo"
            error={errors.loan?.loanAcNo}
            touched={touched.loan?.loanAcNo!}
          />
        )}
        <div>
          {interestAccruals?.visible && (
            <CustomSelect
              requiredStar={interestAccruals?.required}
              disabledField={
                interestAccruals?.disabled ||
                isProportionateLead ||
                values.loan?.lifeCoverOptionCode === "level" ||
                (values.loan?.lifeCoverOptionCode === "reducing" &&
                  [partners.JIO, partners.SREI, partners.CAPRI]?.includes(partnerId))
              }
              label={interestAccruals?.label}
              options={["Yes", "No"]}
              onChange={handleChange}
              setFieldTouched={setFieldTouched}
              name="loan.interestPeriod"
              value={
                values.loan?.lifeCoverOptionCode === "reducing" && partnerId === partners.JIO
                  ? "No"
                  : values.loan.interestPeriod
              }
              error={errors.loan?.interestPeriod}
              touched={touched.loan?.interestPeriod}
            />
          )}
        </div>
        {moratoriumPeriodField?.visible && (
          <div>
            <CustomSelect
              requiredStar={
                moratoriumPeriodField?.required || values.loan?.lifeCoverOptionCode !== "level"
              }
              disabledField={
                moratoriumPeriodField?.disabled ||
                isProportionateLead ||
                values.loan?.lifeCoverOptionCode === "level" ||
                partnerId === partners.JIO
                //  || values.loan?.interestPeriod === "No"
              }
              // disabledField={
              //   values.loan?.lifeCoverOptionCode === "level" || values.loan?.interestPeriod === "No"
              // }
              label={moratoriumPeriodField?.label}
              options={
                // eslint-disable-next-line no-nested-ternary
                [PRODUCT_ID.GHS, PRODUCT_ID.GHS_FOR_JIO, PRODUCT_ID.GHS_IDBI]?.includes(productId!)
                  ? filteredMoratoriumPeriodOptions
                  : productId === PRODUCT_ID.GCS
                  ? (Object.values(moratoriumPeriod) as string[])
                  : Object.values(moratoriumPeriod)
              }
              onChange={handleChange}
              setFieldTouched={setFieldTouched}
              name="loan.moratoriumPeriodWith"
              value={values.loan.moratoriumPeriodWith}
              error={errors.loan?.moratoriumPeriodWith}
              touched={touched.loan?.moratoriumPeriodWith}
            />
            <CustomHelperText className="!flex !justify-between">
              <>
                <div>(With Interest)</div>
                <div className="text-right">{loanPageHelperText.moratoriumPeriod}</div>
              </>
            </CustomHelperText>
          </div>
        )}
        {/* <div>
          <CustomSelect
            // requiredStar={values.loan?.lifeCoverOptionCode !== "level"}
            label="Moratorium Period"
            disabledField={values.loan?.lifeCoverOptionCode === "level"}
            options={Object.values(moratoriumPeriodWithoutInterest)}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="loan.moratoriumPeriodWithout"
            value={values.loan.moratoriumPeriodWithout}
            error={errors.loan?.moratoriumPeriodWithout}
            touched={touched.loan?.moratoriumPeriodWithout}
          />
          <CustomHelperText className="!flex !justify-between">
            <>
              <div>(Without Interest)</div>
              <div className="text-right">{loanPageHelperText.moratoriumPeriod}</div>
            </>
          </CustomHelperText>
        </div> */}
        {emiAmount?.visible && (
          <CustomTextField
            requiredStar={emiAmount?.required}
            disabledField={emiAmount?.disabled || isProportionateLead}
            label={emiAmount?.label}
            onChange={(event) => handelIndianCurrencyChange(event, { setFieldValue })}
            handleBlur={handleBlur}
            value={onChangeIndianCurrency(values.loan.emiAmount)}
            name="loan.emiAmount"
            error={errors.loan?.emiAmount}
            touched={touched.loan?.emiAmount}
          />
        )}
        {term?.visible && (
          <CustomSelect
            requiredStar={term?.required}
            disabledField={term?.disabled || isProportionateLead}
            label={term?.label}
            options={Object.values(loanTerm)}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="loan.loanTerm"
            value={values.loan.loanTerm}
            error={errors.loan?.loanTerm}
            touched={touched.loan?.loanTerm}
          />
        )}
        {loanAmount?.visible && (
          <CustomTextField
            requiredStar={loanAmount?.required}
            disabledField={loanAmount?.disabled || isProportionateLead || isProportionateParent}
            label={loanAmount?.label}
            onChange={(event) => handelIndianCurrencyChange(event, { setFieldValue })}
            handleBlur={handleBlur}
            name="loan.loanAmount"
            value={onChangeIndianCurrency(values.loan.loanAmount)}
            error={errors.loan?.loanAmount}
            touched={touched.loan?.loanAmount}
          />
        )}
        {values.plan.coverOptionCode === CoverType.PROPORTIONATE && (
          <>
            {noOfCoBorrowers?.visible && (
              <CustomTextField
                requiredStar={noOfCoBorrowers?.required}
                disabledField={noOfCoBorrowers?.disabled}
                label={noOfCoBorrowers?.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                name="loan.noOfCoBorrowers"
                value={String(values.loan.noOfCoBorrowers)}
                error={errors.loan?.noOfCoBorrowers}
                touched={touched.loan?.noOfCoBorrowers}
              />
            )}
            {/* {shareofLoan?.visible && (
              <CustomTextField
                label={shareofLoan?.label}
                requiredStar={shareofLoan?.required}
                disabledField={shareofLoan?.disabled}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.loan.share}
                name="loan.share"
                error={errors.loan?.share}
                touched={touched.loan?.share}
              />
            )} */}
          </>
        )}
        {emiFrequency?.visible && (
          <CustomTextField
            requiredStar={emiFrequency?.required}
            disabledField={emiFrequency?.disabled || isProportionateLead}
            label={emiFrequency?.label}
            onChange={handleChange}
            handleBlur={handleBlur}
            value={values.loan.emiFrequency}
            name="loan.emiFrequency"
            error={errors.loan?.emiFrequency}
            touched={touched.loan?.emiFrequency!}
          />
        )}
        {loanInterestRate?.visible && (
          <CustomTextField
            requiredStar={
              loanInterestRate?.required || values.loan?.lifeCoverOptionCode !== "level"
            }
            disabledField={
              loanInterestRate?.disabled ||
              isProportionateLead ||
              values.loan?.lifeCoverOptionCode === "level"
            }
            label={loanInterestRate?.label}
            onChange={handleChange}
            handleBlur={handleBlur}
            value={values.loan.loanInterestRate}
            name="loan.loanInterestRate"
            error={errors.loan?.loanInterestRate}
            touched={touched.loan?.loanInterestRate!}
          />
        )}
        {lifeAssuredShareOfLoan?.visible && (
          <div className="!flex ">
            <CustomRadioButton
              label={lifeAssuredShareOfLoan?.label}
              setFieldTouched={setFieldTouched}
              // handleBlur={handleBlur}
              optionContainerClasses="!flex-col !flex sm:!flex-row"
              name="loan.lifeAssuredShareOfLoan"
              className="!flex !items-center"
              defaultValueIndex={ShareOfLoanOptions?.indexOf(values?.loan?.lifeAssuredShareOfLoan)}
              touched={touched.loan?.lifeAssuredShareOfLoan}
              options={ShareOfLoanOptions}
              setFieldValue={setFieldValue}
              defaultValue={values?.loan?.lifeAssuredShareOfLoan}
            />
          </div>
        )}
        {disbursementDate?.visible && (
          <CustomDatePicker
            requiredStar={disbursementDate?.required}
            disableFuture
            disableField={disbursementDate?.disabled || isProportionateLead}
            label={disbursementDate?.label}
            setFieldValue={setFieldValue}
            name="loan.dateOfDisbursement"
            value={values.loan.dateOfDisbursement}
            error={errors.loan?.dateOfDisbursement}
            touched={touched.loan?.dateOfDisbursement}
            setFieldTouched={setFieldTouched}
          />
        )}
        {lipAccountNo?.visible && (
          <CustomTextField
            label={lipAccountNo?.label}
            requiredStar={lipAccountNo?.required}
            disabledField={lipAccountNo?.disabled || isProportionateLead}
            onChange={handleChange}
            handleBlur={handleBlur}
            value={values.loan.lipAccNo}
            name="loan.lipAccNo"
            error={errors.loan?.lipAccNo}
            touched={touched.loan?.lipAccNo}
          />
        )}
      </div>
    </div>
  );
}

export default memo(Loan);
